import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';
import defaultLang from './en.json';

export default class LanguageStore {
    version = '1.0';

    observed = {
    };

    translations = defaultLang;
    currentLocale = 'en';
    hasPrivacyText = false;
    hasScheduleHeadingText = false;

    constructor() {
        makeObservable(this, {
            observed: observable,
        });

        withActions(this, actions);
    }

}

export function useLanguageStore () {
    const { store } = useStores();
    return store.languageStore;
}
